(function () {
  'use strict';

  function initSlider(track) {
    var sectionId = track.id.replace('sbc-track-', '');
    var fill = document.getElementById('sbc-fill-' + sectionId);
    if (!fill) return;

    function updateFill() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        fill.style.width = '100%';
        return;
      }
      var progress = track.scrollLeft / maxScroll;
      fill.style.width = (progress * 100).toFixed(2) + '%';
    }

    track.addEventListener('scroll', updateFill, { passive: true });
    updateFill();
    window.addEventListener('load', updateFill);

    // Auto-scroll active slide into view on mobile
    var activeSlide = track.querySelector('.sbc-slide.is-active');
    if (activeSlide) {
      // Wait until layout is stable
      requestAnimationFrame(function () {
        var trackRect = track.getBoundingClientRect();
        var slideRect = activeSlide.getBoundingClientRect();
        var offset =
          slideRect.left -
          trackRect.left -
          (track.clientWidth / 2) +
          (slideRect.width / 2);
        track.scrollTo({
          left: track.scrollLeft + offset,
          behavior: 'smooth'
        });
      });
    }
  }

  function centerActiveDesktop(wrapper) {
    var grid = wrapper.querySelector('.sbc-grid');
    if (!grid) return;
    var activeItem = grid.querySelector('.sbc-item.is-active');
    if (!activeItem) return;
    // Only auto-scroll if grid is actually overflowing
    if (grid.scrollWidth <= grid.clientWidth) return;

    requestAnimationFrame(function () {
      var gridRect = grid.getBoundingClientRect();
      var itemRect = activeItem.getBoundingClientRect();
      var offset =
        itemRect.left -
        gridRect.left -
        (grid.clientWidth / 2) +
        (itemRect.width / 2);
      grid.scrollTo({
        left: grid.scrollLeft + offset,
        behavior: 'smooth'
      });
    });
  }

  function initAll() {
    document
      .querySelectorAll('.sbc-slider__track')
      .forEach(function (track) {
        initSlider(track);
      });

    document
      .querySelectorAll('.sbc-wrapper')
      .forEach(function (wrapper) {
        centerActiveDesktop(wrapper);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor: section reloaded or block added/removed
  document.addEventListener('shopify:section:load', function (e) {
    var track = e.target.querySelector('.sbc-slider__track');
    if (track) initSlider(track);
    var wrapper = e.target.querySelector('.sbc-wrapper');
    if (wrapper) centerActiveDesktop(wrapper);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var sliderRoot = e.target.closest('.sbc-slider');
    if (sliderRoot) {
      var t = sliderRoot.querySelector('.sbc-slider__track');
      if (t) {
        var fill = document.getElementById(t.id.replace('sbc-track-', 'sbc-fill-'));
        if (fill) {
          var maxScroll = t.scrollWidth - t.clientWidth;
          fill.style.width = maxScroll > 0
            ? ((t.scrollLeft / maxScroll) * 100).toFixed(2) + '%'
            : '100%';
        }
      }
    }
  });

})();